import { ArrowStatefulIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import useRouter from 'use-react-router';
import './Box.pcss';

type Props = {
  className?: string;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

type HeadingProps = Props & { backLink?: string };

export const Box = ({ className, ...rest }: Props) => (
  <div className={classNames(className, 'c-box')} {...rest} />
);

export const BoxHeading = ({ className, children, backLink }: HeadingProps) => {
  const { history } = useRouter();
  return (
    <div className={classNames(className, 'c-box-heading')}>
      {backLink && (
        <div className="c-box-heading__back">
          <div
            className="c-box-heading__back-link-wrapper"
            onClick={() => history.push(backLink)}
          >
            <ArrowStatefulIcon
              color="#3952FA"
              size={21}
              direction="left"
              className="c-box-heading__back-link-arrow"
            />
            <span className="c-box-heading__back-link">Back</span>
          </div>
        </div>
      )}
      <div className={classNames(className, 'c-box-heading__content')}>
        {children}
      </div>
    </div>
  );
};

export const BoxSidebar = ({ className, children }: Props) => {
  return (
    <div className={classNames(className, 'c-box-sidebar')}>{children}</div>
  );
};

export const BoxSidebarItem = ({ className, children }: Props) => {
  return (
    <div className={classNames(className, 'c-box-sidebar-item')}>
      {children}
    </div>
  );
};

export const BoxContent = ({ className, ...rest }: Props) => (
  <div className={classNames(className, 'c-box-content')} {...rest} />
);
